module.exports = __webpack_public_path__ + "img/mount7.47649f50.jpg";